// Redis Clear Cache Update Actions
const RCC_UPDATE_PROP_VAL = 'RCC_UPDATE_PROP_VAL';
const RCC_RESET_STATE = 'RCC_RESET_STATE';

export const actionTypes = {
  RCC_UPDATE_PROP_VAL,
  RCC_RESET_STATE,
};